import g from "./content-cards-provider-factory.js";
import e from "../managers/braze-instance.js";
export function getCachedContentCards() {
  if (e.rr()) return g.er().Us(!1);
}
